import { Spin, Table, message } from "antd";
import { useCallback, useEffect, useState } from "react";
import dayjs from "dayjs";
import type { ColumnsType } from "antd/es/table";
import empty_png from "@/images/empty.png";
import { serviceApi } from "@/apis";

const Detailstable = ({
  type,
  pickerDate,
  curSegment,
  customerCode,
}: {
  type: string;
  pickerDate: any;
  curSegment: string;
  customerCode?: string;
}) => {
  const [loading, setLoading] = useState(false);
  // 表格信息
  const [curPage, setCurPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [tableData, setTableData] = useState<BalFindAllByPageItems[]>([]);

  const columns: ColumnsType<BalFindAllByPageItems> = [
    {
      title: "账款明细类型",
      dataIndex: "",
      // width: 100,
      key: "",
      render: () => <span>{type === "1" ? "应付明细" : "付款明细"}</span>,
    },
    {
      title: "金额(元)",
      dataIndex: "paymentAmount",
      // width: 100,
      key: "paymentAmount",
    },
    {
      title: "操作日期",
      dataIndex: "paymentDate",
      key: "paymentDate",
    },
  ];

  const handleSearch = useCallback(
    async (curPage: number, pickerDate: any) => {
      try {
        setLoading(true);
        const paymentDateStart = dayjs(pickerDate[0]).format("YYYYMMDD");
        const paymentDateEnd = dayjs(pickerDate[1]).format("YYYYMMDD");
        const api = type === "1" ? "balance_findByConditions" : "balance_findAllByPage";
        const params =
          type === "1"
            ? {
                kunnr: customerCode || "",
                paymentDateStart,
                paymentDateEnd,
                size: 20,
                page: curPage,
              }
            : {
                paymentType: "01",
                creditCode: curSegment,
                customerCode: customerCode || "",
                paymentDateStart,
                paymentDateEnd,
                size: 20,
                page: curPage,
              };
        const res = await serviceApi[api](
          params as unknown as BalFindByConditionsParams & BalFindAllByPageParams
        );
        const { records, total } = res;
        setTotal(total);
        // 付款明细列表
        let lists: BalFindAllByPageItems[] =
          records as unknown as BalFindAllByPageItems[];
        // 应付明细
        if (type === "1") {
          lists = [];
          (records as unknown as BalFindByConditionsItems[])?.forEach((el) => {
            const _item = {
              paymentAmount: Number(el.hjje || 0) + Number(el.hjse || 0),
              paymentDate: el.kprq,
            };
            lists.push(_item);
          });
        }
        setTableData(lists);
        setLoading(false);
      } catch (error: any) {
        setLoading(false);
        message.error(error);
      }
    },
    [type, curSegment, customerCode]
  );

  useEffect(() => {
    setCurPage(1);
    if (pickerDate && pickerDate.length > 1 && curSegment) {
      handleSearch(1, pickerDate);
    }
  }, [pickerDate, handleSearch, curSegment]);

  const changePage = (page: number) => {
    setCurPage(page);
    handleSearch(page, pickerDate);
  };

  return (
    <Spin spinning={loading}>
      <Table
        className="balance-table"
        columns={columns}
        dataSource={tableData}
        locale={{
          emptyText: (
            <div style={{ marginBottom: 30 }}>
              <img src={empty_png} alt="暂无数据" />
              <p>暂无数据</p>
            </div>
          ),
        }}
        pagination={{
          current: curPage,
          total,
          defaultPageSize: 20,
          onChange: changePage,
        }}
      />
    </Spin>
  );
};

export default Detailstable;
